import React from 'react';
import cm from 'classnames';

import styles from '../_input.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export const InputRange = ({ className, value, ...rest }: Props) => {
  return <input type="range" value={value} {...rest} className={cm(styles.InputRange, className)} />;
};
